export enum OverlayType {
    'Button' = 'button',
    'Image' = 'image',
    'Text' = 'text',
    'Submit' = 'submit',
    'Select' = 'select',
    'Input' = 'input',
    'Checkbox' = 'checkbox'
}
